import { keyframes } from '@emotion/react'

export const mediumSpeed = '.3s'
export const slowSpeed = '.6s'

export const transformIn = keyframes`
  100% {
    transform: none;
    opacity: 1;
  }
`

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const bounce = keyframes`
  from,
  20%,
  53%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0);
  }

  90% {
    transform: translate3d(0, -4px, 0);
  }
`

export const bounceMinor = keyframes`
  from,
  20%,
  53%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30%, 0);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15%, 0);
  }

  90% {
    transform: translate3d(0, -4%, 0);
  }
`

export const marqueeLtr = keyframes`
  from {
    transform: translateY(-25%);
  }
  to {
    transform: translateY(-75%);

  }
`

export const marqueeRtl = keyframes`
  from {
    transform: translateY(-30%);
  }
  to {
    transform: translateY(-80%);
  }
`
